import styled from 'styled-components'

export const Container = styled.div`
  flex: 1;

  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;

  padding: 24px 0;
  box-sizing: border-box;
`

export const LabelDescription = styled.label`
  color: var(--foreground-neutral-faded, var(--foreground-neutral-faded, #4d5874));

  /* Body 2/Regular */
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
`

export const LabelHint = styled.label`
  color: var(--Foreground-Neutral-faded, #4d5874);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`
